'use strict';

import jQuery from 'jQuery';
import videojs from 'video.js';
import mobileNav from './mobileNav';
import desktopNav from './desktopNav';
import aboutPage from './aboutPage';
import homePage from './homePage';
import workVideos from './workVideos';

window.$ = jQuery;

$(function () {

  // cache selectors
  let $body = $('body');
  let $content = $('.site-content');

  // utility functions
  let isPage = function (handle) {
    return $body.hasClass(`page-${handle}`);
  };

  let isCategory = function (handle) {
    return $body.hasClass(`category-page-${handle}`);
  }

  // Global actions
  // =================================================
  $content.addClass('is-in-view');
  mobileNav();
  desktopNav();

  // Category-specific actions
  // =================================================
  if (isCategory('about')) {
    aboutPage();
  }

  if (isCategory('work')) {
    workVideos();
  }

  // Page-specific actions
  // =================================================
  if (isPage('home')) {
    homePage();
  }

});



// WEBPACK FOOTER //
// ./main.js